import { lazy, Suspense } from "react"

import{createBrowserRouter, RouterProvider } from "react-router-dom"
const Browser =lazy(()=>import("./Browse") )

const Watch =lazy(()=>import("./Watch") )
const Body =()=>{

 
    const appRouter =createBrowserRouter([
        {
            path:"/",
            element:<Suspense fallback={<h1>Loading...</h1>} ><Browser/></Suspense>
        },
        {
            path:"/browse",
            element:<Suspense fallback={<h1>Loading...</h1>} ><Browser/></Suspense>
        },
        {
            path:"/watch",
            element:<Suspense fallback={<h1>Loading...</h1>} ><Watch/></Suspense>
        }
    ]);
   
    return <div className="flex flex-col ">
        
       <RouterProvider router= {appRouter}/>
    </div>
}
export default Body